import React, { Component } from "react";
import PropTypes from "prop-types";
import { ConnectedRouter } from "connected-react-router/immutable";
import { connect } from "react-redux";
import Navbar from "../../components/NavBar";
import routes from "../../routes";
import "semantic-ui-css/semantic.css";
import "../../style/css/style.css";

class App extends Component {
  render() {
    const { history } = this.props;
    return (
      <React.Fragment>
        <Navbar />
        <ConnectedRouter history={history}>{routes}</ConnectedRouter>
      </React.Fragment>
    );
  }
}
App.propTypes = {
  history: PropTypes.object,
  user: PropTypes.object,
};

export default connect((state) => ({
  user: state.get("auth").get("user"),
}))(App);
